﻿export const ko = {
  apply: "적용하기",
  cart_is_empty: "장바구니가 비어 있습니다. 장바구니에 추가할 제품을 찾아보십시오",
  browse_products: "제품 살펴보기",
  invalid_coupon: "유효하지 않은 할인 코드를 입력하셨습니다. 코드를 확인하고 다시 시도해 주십시오.",
  duplicate_coupon: "할인 코드 {{couponInputValue}}가 이미 적용되었습니다",
  products: "제품",
  product: "제품",
  qty: "개수",
  price: "가격",
  remove: "제거하기",
  add_to_cart: "장바구니에 추가하기",
  show_more: "자세히 보이기",
  show_less: "접기",
  order_summary: "주문 요약",
  your_cart: "장바구니",
  item: "품목",
  items: "품목",
  enter_discount_code: "할인 코드 입력하기",
  continue_shopping: "계속 쇼핑하기",
  i_agree: "계속 진행함은 다음을 읽었고 수락하는 데 동의하는 것입니다",
  privacy_policy: "프라이버시 정책",
  refund_policy: "환불 정책",
  terms_of_use: "이용 약관",
  and: "및",
  total: "합계",
  exclude: "제외",
  include: "포함",
  tax: "세금",
  subtotal: "세전 합계",
  discount: "할인",
  coupon_discount: "쿠폰 할인",
  checkout: "결제"
};